import Block from "@components/block"
import GoodsCard from "@src/components/goodsCard"
import React from "react"
import * as styles from "./goods.module.scss"
import goodsTitleImg from "@imagesgz/title-goods.png"
import goodsTitleAppImg from "@imagesgz/title-goods-app.png"
import goodsGImg from "@imagesgz/content/goods-g.png"
import goodsBookImg from "@imagesgz/content/goods-book.png"
import goodsToyImg from "@imagesgz/content/goods-toy.png"
import btnEnrollImg from "@imagesgz/content/btn-enroll.png"
import btnTalkImg from "@imagesgz/content/btn-talk.png"
import CardButton from "@src/components/button"
import classnames from "@src/utils/classnames"
import config from "@config"

const goodsList = [
  {
    title:
      "今年吉考斯工业依然准备了现场限定场贩服装, 还准备了解决排队难题的新系统",
    // href: "https://www.gcores.com/articles/142123",
    thumb: goodsGImg,
  },
  {
    title:
      "备受大家期待的 核市奇谭 本次也会参展核聚变，将有首发 核市奇谭独家场贩周边",
    // href: "https://www.gcores.com/articles/142480",
    thumb: goodsBookImg,
  },
  {
    title: "剑玉游戏挑战\r\n在这里迎接大家",
    // href: "https://www.gcores.com",
    thumb: goodsToyImg,
  },
]

const Goods = () => {
  return (
    <Block id="goods" title={[goodsTitleImg, goodsTitleAppImg]}>
      <div className={classnames(styles.goodsList)}>
        {goodsList.map(({ title, href, thumb }) => (
          <GoodsCard
            key={thumb}
            title={title}
            thumb={thumb}
            appNavTo={href}
            disabled={!href}
          />
        ))}
      </div>
      <div className={styles.actions}>
        <CardButton
          className={styles.action}
          appNavTo={config.linksGz.volunteer}
        >
          <img src={btnEnrollImg} alt="报名" />
          <p>成为志愿者&gt;</p>
        </CardButton>
        <CardButton className={styles.action} appNavTo={config.linksGz.topic}>
          <img src={btnTalkImg} alt="讨论" />
          <p>参与话题讨论&gt;</p>
        </CardButton>
      </div>
    </Block>
  )
}

export default Goods
